const e={min:"Select a date (min)",max:"Select a date (max)",type:"Select a date (type)",required:"Select a date"};export{e as validationErrors};
//# sourceMappingURL=validationErrors.js.map
